import React, { useState, useRef, useEffect } from "react";
import './navbar.scss';
import { MdTravelExplore } from "react-icons/md";
import { GiScissors } from "react-icons/gi"; 
import { Link } from "react-router-dom";
import TailorMadeForm from "../Tailor/TailorMadeForm";
import useCloseNavOnRouteChange from "../Tools/useCloseNavOnRouteChange";
import logo from "../../assets/logo.png"
const Navbar = () => {
  const [navOpen, setNavOpen] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [categories, setCategories] = useState([]);

  const navRef = useRef(null);

  const toggleNav = () => setNavOpen(!navOpen);
  const closeNav = () => setNavOpen(false);

  useCloseNavOnRouteChange(closeNav);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (
        navRef.current && 
        !navRef.current.contains(e.target) &&
        !e.target.closest(".hamburger")
      ) {
        closeNav();
      }
    };

    if (navOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [navOpen]);

  // ✅ جلب الكاتيجوريز من API
  useEffect(() => {
    fetch("https://admin.mythsegypttours.com/api/categories") // غير الرابط حسب السيرفر
      .then(res => res.json())
      .then(data => setCategories(data))
      .catch(err => console.error(err));
  }, []);

  return (
    <>
      <section className="navBarSection">
        <header className="header flex">

          {/* Logo */}
          <div className="logoDiv">
            <Link to="/" className="logo flex" onClick={closeNav}>
               <img src={logo} alt="myths EGYPT TRAVEL" />
            </Link>
          </div>

          {/* Menu */}
          <div ref={navRef} className={`navBar ${navOpen ? "activeNavbar" : ""}`}>
            <ul className="navLists flex">
              <li className="navItem"><Link to="/" className="navLink" onClick={closeNav}>Home</Link></li>
              <li className="navItem"><Link to="/packages" className="navLink" onClick={closeNav}>Packages</Link></li>
              
              {/* ✅ Tours Dropdown */}
             <li className="navItem dropdown">
  <Link to="/tours" className="navLink" onClick={closeNav}>
    Tours 
    {/* ▾ */}
  </Link>
  {/* <ul className="dropdownMenu">
    {categories.map(cat => (
      <li key={cat.id}>
        <Link 
          to={`/tours/${cat.slug}`} 
          className="dropdownLink" 
          onClick={closeNav}
        >
          {cat.title}
        </Link>
      </li>
    ))}
  </ul> */}
</li>


              <li className="navItem"><Link to="/about-us" className="navLink" onClick={closeNav}>About Us</Link></li>
              <li className="navItem"><Link to="/contact" className="navLink" onClick={closeNav}>Contact Us</Link></li>
            </ul>
          </div>

          {/* Tailor-Made Button */}
          <div className="tailorCard">
            <button 
              className="tailorBtn"
              onClick={() => setOpenModal(true)}
            >
              <span className="tailorText">Tailor-Made</span>
              <span className="tailorIconWrapper">
                <GiScissors className="tailorIcon" />
              </span>
            </button>
          </div>

          {/* Hamburger Button */}
          <div className={`hamburger ${navOpen ? "open" : ""}`} onClick={toggleNav}>
            <span></span>
            <span></span>
            <span></span>
          </div>

        </header>
      </section>

      {/* Modal */}
      {openModal && (
        <div className="modal-overlay" onClick={() => setOpenModal(false)}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <button 
              className="modal-close" 
              onClick={() => setOpenModal(false)}
            >
              ✖
            </button>
            <TailorMadeForm />
          </div>
        </div>
      )}
    </>
  );
};

export default Navbar;
